import { BaseEntity } from "../entities";
import { ApiClient } from "./client"

export class DeliveryProvider {
    private static _apiClient = new ApiClient();

    static async get(id: number) {
        return await this._apiClient.get(`/delivery/${id}`) as Delivery;
    }

    static async getAllByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/delivery/by-organisation/all?organisationId=${organisationId}&page=${page}&size=${size}`) as Delivery[];
    }

    static async getMyByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/delivery/by-organisation/my?organisationId=${organisationId}&page=${page}&size=${size}`) as Delivery[];
    }

    static async save(delivery: Delivery) {
        return await this._apiClient.post('/delivery', delivery) as number;
    }
}

export interface Delivery extends BaseEntity {
    DeliveryId: number
    DeliveryAssignedTo: number
    DeliveryAssignedTo2: number
    DeliveryDesponsible: number
    DeliveryStatus: DeliveryStatus
    DeliveryPhase: number
    DeliveryOrderDate: string
    DeliveryOrderValue: number
    DeliveryOpportunityCurrencyName: string
    DeliveryDescription: string
    DeliveryNumber: string
    DeliveryOrganisationId: number
    DeliveryPersonId: number
    DeliveryPersonName: string
}

export enum DeliveryStatus {
    GeneralDelivery = 'GeneralDelivery',
    New = 'New',
    Planned = 'Planned',
    OnGoing = 'OnGoing',
    Completed = 'Completed',
}
